<template>
  <div class="wrap common-container el-row-overflow">
    <h2 class="public-title">总部支持</h2>
    <div class="clearfix">
      <div class="support-swiper">
        <div class="swiper-container ">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item,index) in supportData" :key="index" data-name="111">
              <div class="swiper-content">
                <div class="support-content">
                  <h4 class="support-title">{{item.name}}</h4>
                  <div v-html="item.content"></div>
                </div>
                <img class="support-img" :src="require('@/assets/images/img/'+item.imgSrc)" alt="">
              </div>
                <div class="white-bg"></div>
                <div class="mask-bg"></div>
            </div>
          </div>
          <!-- Add Pagination -->
          <div class="swiper-pagination">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script >
import { defineComponent, ref, reactive, onMounted } from "vue";
import Swiper from "swiper";
export default defineComponent({
  setup() {
    const supportData = reactive([
      {
        name: "品牌支持",
        imgSrc: "img_ppzc.jpg",
        content:
          "<p>1.&nbsp;享有文都品牌使用权，享有总部所有荣誉</p><p>2.&nbsp;以区域或地区为单位独家合作，维护合作校区利益</p><p>3.&nbsp;提供门店装修、室内装修设计方案，同一标识、同一形象</p>"
      },
      {
        name: "运营支持 ",
        imgSrc: "img_yyzc.jpg",
        content:
          "<p>1.&nbsp;市场运作指导</p><p>2.&nbsp;选址支持</p><p>3.&nbsp;同一整体广告投放</p><p>4.&nbsp;物料支持</p><p>5.&nbsp;先进的校区运营管理系统</p><p>6.&nbsp;给予人力招聘协助和支持</p>"
      },
      {
        name: "培训支持",
        imgSrc: "img_pxzc.jpg",
        content:
          "<p>1.&nbsp;行业知识培训</p><p>2.&nbsp;校区运作知识的培训</p><p>3.&nbsp;从业人员的多方位业务培训</p><p>4.&nbsp;管理者岗位各方面能力提升</p>"
      },
      {
        name: "技术支持",
        imgSrc: "img_jszc.jpg",
        content:
          "<p>1.&nbsp;分校建设、网络招生系统化解决方案</p><p>2.&nbsp;校区运营管理系统维护和管理</p><p>3.&nbsp;专业研发团队，研发新产品、新项目</p>"
      },
      {
        name: "教学支持",
        imgSrc: "img_jxzc.jpg",
        content:
          "<p>1.&nbsp;教师教研培训</p><p>2.&nbsp;实地教学解决方案</p><p>3.&nbsp;名师专家团队支持</p><p>4.&nbsp;专业丰富的图书、讲义</p><p>5.&nbsp;提供网络视频课件作为授课资源</p>"
      },
      {
        name: "招生支持",
        imgSrc: "img_zszc.jpg",
        content:
          "<p>1.&nbsp;新校区的市场推广方案</p><p>2.&nbsp;派驻精英销售管理团队给予支持</p><p>3.&nbsp;校区产品植入，丰富校区产品线</p>"
      }
    ]);

    onMounted(() => {
      // 总部支持
      var supportSwiper = new Swiper(".support-swiper .swiper-container", {
        pagination: ".support-swiper .swiper-pagination",
        paginationClickable :true,
        // slidesPerView: "2",
        slidesPerView: 'auto',
        // autoplay: 5000,
        autoplay:false,
        direction: "vertical",
        // loop: true,
        autoplayDisableOnInteraction: false,
        mousewheelControl: true,
        speed: 200,
        paginationBulletRender: function(swiper, index, className) {
        let nameTxt=supportData[index].name
          return '<span class="' + className + '">' + nameTxt + "</span>";
        },
      });
    });
    return {
      supportData
    };
  }
});
</script>

<style lang="scss" scoped type="text/scss">
.support-swiper {
    position: relative;
    width:100%;
    overflow: hidden;
  .white-bg{
      display:none;
      position:absolute;
      left:0;
      top:0;
      width:1000px;
      height:480px;
      background:#fff;
  }
  .swiper-slide-active{
      .white-bg{
          display:block;
      }
  }
  .swiper-slide-next{
      opacity: 0.3;
  }
  .swiper-container {
      height: 480px;
    // height:800px;
    padding-bottom:320px;
   .swiper-slide{
       position:relative;
       height:480px !important;
    overflow: hidden;
   }
  }
  .swiper-content {
      position:relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding-right:120px;
    padding-top:30px;
    padding-bottom:30px;
    overflow: hidden;
    z-index: 2;
  }
  .support-img {
    float:left;
    width: 560px;
    height: 420px;
    flex-shrink: 0;
    object-fit: cover;
  }
  .support-content {
    padding: 0 64px;
    font-size: 16px;
    float: left;
    width: 100%;
    flex-shrink: 1;
    p {
      margin-bottom: 16px;
    }
  }
  .support-title {
    font-size: 24px;
    margin-bottom: 32px;
  }

  .swiper-pagination{
      left:initial;
      right:0;
      top:30px;
      width:120px;
      transform: translate3d(0,0,0);
      /deep/ .swiper-pagination-bullet{
          position:relative;
          display:block;
          width:100%;
          height:70px;
          background:none;
          color:#1B1D1F;
          line-height: 70px;
          font-size:16px;
          font-weight:bold;
          opacity: 1;
          box-sizing: border-box;
          border-radius:0;
          margin:0;
          &:after{
              position:absolute;
              right:0;
              top:5px;
              content:'';
              width:4px;
              height:60px;

              background:#E9F0F6;
          }
      }
      /deep/ .swiper-pagination-bullet-active{
          color:#0099FF;
          &:after{
              background:#0099FF;
          }
      }
  }
}
</style>
